import { NgtUniversalModule } from "@ng-toolkit/universal";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { NotFoundComponent } from "./not-found/not-found.component";
import { HomeComponent } from "./components/home/home.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { ScriptService } from "./services/script.service";
import { BrandService } from "./services/brand.service";
import { CartService } from "./services/cart.service";
import { ApiService } from "./services/api.service";
import { SEOService } from "./services/seo.service";
import { APIPostService } from "./services/post.service";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TransferHttpModule, TransferHttpService } from "@gorniv/ngx-universal";
import { TransferHttpCacheModule } from "@nguniversal/common";
import { NgxJsonLdModule } from "ngx-json-ld";
import { CardModule } from "ngx-card";
import { ProductsComponent } from './components/products/products.component';
import { ProductComponent } from './components/product/product.component';
import { SearchComponent } from './components/search/search.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { ShippingDeliveryComponent } from './components/shipping-delivery/shipping-delivery.component';
import { PricingComponent } from './components/pricing/pricing.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    ProductsComponent,
    ProductComponent,
    SearchComponent,
    CartComponent,
    CheckoutComponent,
    AboutComponent,
    ContactComponent,
    TestimonialsComponent,
    GalleryComponent,
    ShippingDeliveryComponent,
    PricingComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    BrowserModule.withServerTransition({ appId: "app-root" }),
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    NgtUniversalModule,
    AppRoutingModule,
    TransferHttpCacheModule,
    TransferHttpModule,
    NgxJsonLdModule,
    CardModule
  ],
  providers: [
    ScriptService,
    BrandService,
    CartService,
    ApiService,
    SEOService,
    APIPostService,
    TransferHttpService
  ],
})
export class AppModule {}
